import Eslang from './entries/es_ES'

const AppLocale = {
  es: Eslang,
}

export default AppLocale
